import get from 'lodash/get';
import find from 'lodash/find';

import {
  SET_SELECTED_PARAMETERS,
  RESET_SELECTED_PARAMETERS,

  SET_SELECTED_PARAMETERS_FILTER,
  RESET_SELECTED_PARAMETERS_FILTER,
  TOGGLE_SELECTED_PARAMETER_VISIBILITY
} from './types';

import {
  getSelectedParameterType,
  getVisibleNumericalSelectedParametersNames
} from './selectors';
import { samplingDistributions, linearModel } from 'mobx-store';
import { resetLinearModelForm } from 'store/form/linearModel/actions';
import { setPrimaryAndSecondary } from 'store/scenes/linearModel/actions';
import { resetParametersInferentialStatisticsPage } from 'store/scenes/inferentialStatistics/actions';
import { getNumericalRowDataSet, getCategoricalRowDataSet } from 'store/form/inferentialStatistics';
import { getNumericalRowDataSetFirst, getNumericalRowDataSetSecond } from 'store/form/inferentialStatistics/pairedT/selectors';

import {
  getPrimaryParameterName as getGraphicalStatisticsPrimaryParameterName,
  getSecondaryParameterName as getGraphicalStatisticsSecondaryParameterName,
  getSettingsPane as getParameterNames
} from 'store/scenes/graphicalStatistics/settingsPane/selectors';

import { resetGraphicalStatistics } from 'store/scenes/graphicalStatistics/actions';

import * as store from 'store';

export const setSelectedParameterFilter = (parameter, payload) => dispatch => {
  dispatch([
    { type: SET_SELECTED_PARAMETERS_FILTER, parameter, payload },
    resetParametersInferentialStatisticsPage(),
    setPrimaryAndSecondary(
      linearModel.primaryParameter && linearModel.primaryParameter.name,
      linearModel.secondaryParameter && linearModel.secondaryParameter.name
    )
  ]);
};

export const resetSelectedParameterFilter = parameter => dispatch => {
  dispatch([
    { type: RESET_SELECTED_PARAMETERS_FILTER, parameter },
    resetParametersInferentialStatisticsPage(),
    setPrimaryAndSecondary(
      linearModel.primaryParameter && linearModel.primaryParameter.name,
      linearModel.secondaryParameter && linearModel.secondaryParameter.name
    )
  ]);
};

export const toggleSelectedParameterVisibility = parameterName => (dispatch, getState) => {
  const state = getState();
  const numericalRowDataSet = getNumericalRowDataSet(state);
  const categoricalRowDataSet = getCategoricalRowDataSet(state);
  const numericalRowDataSetForPairedT = getNumericalRowDataSet(state);
  const numericalFirstRowDataSetForPairedT = getNumericalRowDataSetFirst(state);
  const numericalSecondRowDataSetForPairedT = getNumericalRowDataSetSecond(state);
  const parameterNames = getParameterNames(state);
  const numericalSelectedNames = getVisibleNumericalSelectedParametersNames(state);

  dispatch({
    type: TOGGLE_SELECTED_PARAMETER_VISIBILITY, parameterName
  });

  if (parameterNames.primary === parameterName || parameterNames.secondary === parameterName) {
    dispatch(resetGraphicalStatistics());
  }
  if (
    numericalRowDataSet === parameterName ||
    categoricalRowDataSet === parameterName ||
    numericalRowDataSetForPairedT === parameterName ||
    !(numericalSelectedNames.includes(parameterName)) ||
    numericalFirstRowDataSetForPairedT === parameterName ||
    numericalSecondRowDataSetForPairedT === parameterName
  ) {
    dispatch(resetParametersInferentialStatisticsPage());
  }
};

export const setSelectedParameters = parameters => (dispatch, getState) => {
  const state = getState();

  const primaryParameterName = getGraphicalStatisticsPrimaryParameterName(state);
  const secondaryParameterName = getGraphicalStatisticsSecondaryParameterName(state);

  if ((primaryParameterName && !parameters[primaryParameterName]) ||
      (secondaryParameterName && !parameters[secondaryParameterName])) {

    dispatch(resetGraphicalStatistics());
  }

  // INFERENTIAL STATISTICS TAB

  dispatch(resetParametersInferentialStatisticsPage());

  // SAMPLING DISTRIBUTIONS TAB

  const samplingDistributionsParameter = samplingDistributions.parameter.name;

  const samplingDistributionsParameterOldTargetType = getSelectedParameterType(state, samplingDistributionsParameter);
  const samplingDistributionsParameterNewTargetType = get(parameters[samplingDistributionsParameter], 'targetType');

  if (samplingDistributionsParameterOldTargetType !== samplingDistributionsParameterNewTargetType) {
    // resets form on Sampling Distributions Tab
    dispatch(store.form.samplingDistributions.resetSamplingDistributionsForm());

    // resets generated samples
    samplingDistributions.reset();
  }

  // BOOTSTRAP CONFIDENCE INTERVALS TAB

  const bootstrapCIsPrimaryParameter = store.scenes.bootstrapCIs.primaryParameter.getPrimaryParameter(state);
  const bootstrapCIsSecondaryParameter = store.scenes.bootstrapCIs.secondaryParameter.getSecondaryParameter(state);

  const bootstrapCIsPrimaryParameterOldTargetType = bootstrapCIsPrimaryParameter && bootstrapCIsPrimaryParameter.type;
  const bootstrapCIsPrimaryParameterNewTargetType = bootstrapCIsPrimaryParameter && get(find(parameters, ['name', bootstrapCIsPrimaryParameter.name]), 'targetType');

  const bootstrapCIsSecondaryParameterOldTargetType = bootstrapCIsSecondaryParameter && bootstrapCIsSecondaryParameter.type;
  const bootstrapCIsSecondaryParameterNewTargetType = bootstrapCIsSecondaryParameter && get(find(parameters, ['name', bootstrapCIsSecondaryParameter.name]), 'targetType');

  if (bootstrapCIsPrimaryParameterOldTargetType !== bootstrapCIsPrimaryParameterNewTargetType ||
        bootstrapCIsSecondaryParameterOldTargetType !== bootstrapCIsSecondaryParameterNewTargetType) {
    dispatch(store.form.bootstrapCIs.resetBootstrapCIsForm());
  }

  // RANDOMIZATION HYPOTHESIS TESTING TAB

  const randomizationHypothesisTestingPrimaryParameterName = store.scenes.randomizationHypothesisTesting.primaryParameter.getPrimaryParameterName(state);
  const randomizationHypothesisTestingPrimaryParameterOldTargetType = store.scenes.randomizationHypothesisTesting.primaryParameter.getPrimaryParameterType(state);

  const randomizationHypothesisTestingSecondaryParameterName = store.scenes.randomizationHypothesisTesting.secondaryParameter.getSecondaryParameterName(state);
  const randomizationHypothesisTestingSecondaryParameterOldTargetType = store.scenes.randomizationHypothesisTesting.secondaryParameter.getSecondaryParameterType(state);

  const randomizationHypothesisTestingPrimaryParameterNewTargetType = get(parameters[randomizationHypothesisTestingPrimaryParameterName], 'targetType');
  const randomizationHypothesisTestingSecondaryParameterNewTargetType = get(parameters[randomizationHypothesisTestingSecondaryParameterName], 'targetType');

  if (randomizationHypothesisTestingPrimaryParameterOldTargetType !== randomizationHypothesisTestingPrimaryParameterNewTargetType ||
        randomizationHypothesisTestingSecondaryParameterOldTargetType !== randomizationHypothesisTestingSecondaryParameterNewTargetType) {
    dispatch(store.form.randomizationHypothesisTesting.resetRandomizationHypothesisTestingForm());
  }

  // LINEAR MODEL

  const linearModelPrimaryParameterName = linearModel.primaryParameter && linearModel.primaryParameter.name;
  const linearModelPrimaryParameterOldType = linearModel.primaryParameter && linearModel.primaryParameter.type;

  const linearModelSecondaryParameterName = linearModel.secondaryParameter && linearModel.secondaryParameter.name;
  const linearModelSecondaryParameterOldType = linearModel.secondaryParameter && linearModel.secondaryParameter.type;

  const linearModelPrimaryParameterNewType = get(parameters[linearModelPrimaryParameterName], 'targetType');
  const linearModelSecondaryParameterNewType = get(parameters[linearModelSecondaryParameterName], 'targetType');

  if (linearModelPrimaryParameterNewType !== linearModelPrimaryParameterOldType ||
        linearModelSecondaryParameterNewType !== linearModelSecondaryParameterOldType) {

    linearModel.resetPrimaryAndSecondary();
    dispatch(resetLinearModelForm());
  }

  dispatch({ type: SET_SELECTED_PARAMETERS, parameters });
};

export const resetSelectedParameters = () => ({
  type: RESET_SELECTED_PARAMETERS
});
